import { Button } from '@commenda/kakashi';

interface CustomerHeaderProps {
  customerName?: string;
  isEditing: boolean;
  onCancel: () => void;
  onSave: () => void;
  onDelete?: () => void;
}

const CustomerHeader = ({
  customerName,
  isEditing,
  onCancel,
  onSave,
  onDelete,
}: CustomerHeaderProps) => {
  const renderTitle = () => {
    return (
      <div className="flex items-center gap-3">
        <span className="text-text-secondary txt-extra-large-bold">
          {customerName}
        </span>
      </div>
    );
  };

  const renderActions = () => {
    if (isEditing) {
      return (
        <>
          <Button
            variant="secondary"
            size="sm"
            onClick={onCancel}
            type="button"
          >
            Cancel
          </Button>
          <Button type="submit" variant="primary" size="sm" onClick={onSave}>
            Save changes
          </Button>
        </>
      );
    }

    return (
      <Button
        variant="destructive-secondary"
        size="sm"
        onClick={onDelete}
        type="button"
      >
        Delete
      </Button>
    );
  };

  return (
    <div className="h-16 px-6 flex items-center justify-between border-b border-border-primary">
      {renderTitle()}
      <div className="flex items-center gap-3">{renderActions()}</div>
    </div>
  );
};

export default CustomerHeader;
